import { ModalBody, ModalFoot, ModalHead, Text } from '@dixa/lib-shared-habla';
import { ModalWrapper, useModal } from 'lib-knowledge-modal';
import { useNotification } from 'lib-knowledge-utils/hooks/useNotification';

import { useActivateAiSettingsVersion } from '../hooks/useAiSettingsMutations';

export type GoLiveModalProps = {
  versionId: string;
  name: string;
};

/** Asks before the AI switches to another saved version. */
export function GoLiveModal({
  versionId,
  name,
}: GoLiveModalProps): JSX.Element {
  const { hideModal } = useModal();
  const { successNotify, errorNotify } = useNotification();
  const [activateVersion, { loading }] = useActivateAiSettingsVersion();

  const onConfirm = async () => {
    try {
      await activateVersion({ variables: { id: versionId } });
      successNotify({ title: 'Version live', text: `"${name}" is now live.` });
      hideModal();
    } catch {
      errorNotify({ text: `"${name}" could not be made live. Try again.` });
    }
  };

  return (
    <ModalWrapper>
      <ModalHead title={`Go live with "${name}"`} onClose={hideModal} />
      <ModalBody>
        <Text.Paragraph>
          The AI will use this version for new article suggestions, in place of
          the one that is live now.
        </Text.Paragraph>
      </ModalBody>
      <ModalFoot
        confirmName="Go live"
        confirmOnClick={onConfirm}
        confirmProps={{
          isLoading: loading,
          loadingIndicator: 'Going live...',
          disabled: loading,
        }}
        cancelOnClick={hideModal}
        cancelProps={{ variant: 'secondary' }}
      />
    </ModalWrapper>
  );
}
